export default __webpack_public_path__ + "static/media/fya-logo-large.7fcaf395.svg";